export { BtnLoadingDirective } from './Directives/btn-loading.directive';
export { SafeHtmlPipe } from './modal-window/Pipes/sanitize.pipe';

// Imports de módulos
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// Imports de directivas
// Agrega esta línea al principio de shared.config.ts
import { BtnLoadingDirective } from './Directives/btn-loading.directive';
import { SafeHtmlPipe } from './modal-window/Pipes/sanitize.pipe';

// Imports de tus módulos personalizados
import { MATERIAL_MODULES } from './material.config'; // El array que creamos antes
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MATERIAL_LIST_IMPORTS } from './Components/material-list/material-list.config'; // Este sigue siendo un módulo tradicional por ahora
import { MODAL_WINDOW_IMPORTS } from './modal-window/modal-window.config'; // Este sigue siendo un módulo tradicional

// Array con TODO lo que necesitas importar en componentes
export const SHARED_IMPORTS = [
  // Módulos de Angular
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  
  // Material (el array que creamos antes)
  ...MATERIAL_MODULES,
  // Módulos de Material datetime (cuando lo conviertas)
  MatDatepickerModule, MatTimepickerModule,
  // Estos módulos necesitan ser convertidos a standalone o seguir así
  ...MATERIAL_LIST_IMPORTS,
  ...MODAL_WINDOW_IMPORTS,
  BtnLoadingDirective,
  SafeHtmlPipe
];

// Array con las directivas/componentes/pipes compartidos
export const SHARED_DECLARATIONS = [
  BtnLoadingDirective,
  SafeHtmlPipe
];